import { render, staticRenderFns } from "./Osa012.vue?vue&type=template&id=5f891146&scoped=true"
var script = {}
import style0 from "./Osa012.vue?vue&type=style&index=0&id=5f891146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f891146",
  null
  
)

export default component.exports